export default {
  title:
    'Mindestzahlungsbetrag: Wir sind nicht in der Lage, Zahlungen zwischen {{rangeStart}} - {{rangeEnd}} anzunehmen',
  description: 'Ausnahme: Wenn du einen Gratis-Artikel hast, kannst du mit einem Gesamtbetrag von {{amount}} bestellen',
};
